<template lang="pug">
.info-wrapper
  .info-menu
    ul
      li(@click="setMenu('about')")
        a(href='javascript:void(0);' data-tab='info-tab-about' :class="{'active' : generalMenuSelected == 'about'}") Бидний тухай
      li(@click="setMenu('privacy')")
        a(href='javascript:void(0);' data-tab='info-tab-privacy' :class="{'active' : generalMenuSelected == 'privacy'}") Нууцлалын бодлого
      li(@click="setMenu('gaming')")
        a(href='javascript:void(0);' data-tab='info-tab-gaming' :class="{'active' : generalMenuSelected == 'gaming'}") Тоглоомын Хариуцлага
      li(@click="setMenu('banking')")
        a(href='javascript:void(0);' data-tab='info-tab-banking' :class="{'active' : generalMenuSelected == 'banking'}") Банк
      li(@click="setMenu('faqs')")
        a(href='javascript:void(0);' data-tab='info-tab-faqs' :class="{'active' : generalMenuSelected == 'faqs'}") ТҮГЭЭМЭЛ АСУУЛТУУД
  #accordionInfo.accordion
    .accordion-item.info-tab-about.active
      h2.accordion-header
        button.accordion-button(type='button' data-bs-toggle='collapse' data-bs-target='#collapseOne' aria-expanded='true' aria-controls='collapseOne') Бидний тухай
      #collapseOne.accordion-collapse.collapse.show(data-bs-parent='#accordionInfo')
        .accordion-body
          .info-content
            p
              | Энэхүү UBWIN нь казиногийн болон бусад тоглоомоос, хэрэглэгчид болон гишүүдэд хялбар нэвтрэж хэрэглэх боломжийг олгодогоороо ялгаатай юм. UBWIN нь та гэртээ бидэнтэй хамт байгаа мэт таатай сэтгэгдэл төрүүлэхээр бүтээгдсэн. Энэхүү платформ нь тоглогчид бэлэн мөнгө хожиж бодитоор хожилоо авах гайхалтай боломжийг чухалчилдаг. Онлайн казино тоглоом нь сэтгэл хөдөлгөм болон хамгийн сүүлийн үеийн технологиудаас бүрдсэн юм. Мөн түүнчлэн таны аюулгүй найдвартай онлайн төлбөртэй хослуулснаар та сэтгэл амар байх болно. Нэмж дурдахад, манай төлбөр шилжүүлэх үйл явц нь бүх гишүүдэд чанартай байх зорилготой бүтээгдсэн. Бид бүх гишүүддээ үнэнч байдлыг эрхэмлэдэг бөгөөд хууль эрх зүйн бүхий л хүрээнд гишүүдийнхээ сэтгэл ханамжийг илүүд чухалчлан үзэх болно.
            p
              | UBWIN нь шинэлэг өргөн хүрээнд хүн бүр бооцоогоо тавих боломжийг санал болгодог:
            .table-info
              .table-responsive
                table.table.table-new
                  tr
                    th.text-center.align-middle Шууд Казино
                    td
                      | Манай онлайн казинод өдөр, шөнийн аль ч цагт орж, аль ч 5 тансаг люкс өрөөнд шууд дилерүүдээр үйлчлүүлээрэй
                  tr
                    th.text-center.align-middle.rounded-0 Спортууд
                    td
                      | Тоглолтын хамгийн сайн таамаглалаа 6 дахь мэдрэхүйгээ ашиглан хожих спортын  байндаа бооцоогоо тавиарай
                  tr
                    th.text-center.align-middle.rounded-0.border-bottom-0 Тоглоомууд
                    td.border-bottom-0
                      | Манай өргөн хүрээний бусад илүү тайван онлайн тоглоомуудыг ашиглан [ слот болон аркад гэх мэт]  илүү их хожил олох боломжийг эдлээрэй
            p
              | UBWIN-ын багийнхан бүх гишүүддээ үргэлж туслахад бэлэн бөгөөд хэрэв танд асуулт, санал хүсэлт байвал манай харилцагчын үйлчилгээний ажилтнууд тантай шууд чатаар холбогдож болно.
    .accordion-item.info-tab-privacy
      h2.accordion-header
        button.accordion-button.collapsed(type='button' data-bs-toggle='collapse' data-bs-target='#collapseTwo' aria-expanded='false' aria-controls='collapseTwo') Нууцлалын бодлого
      #collapseTwo.accordion-collapse.collapse(data-bs-parent='#accordionInfo')
        .accordion-body
          .info-content
            p
              | UBWIN нь, Тоглогч бүрийн хувийн нууцыг хүндэтгэж хамгаалах бөгөөд тоглогч бүрээс авсан мэдээллийн аюулгүй байдлыг алдагдуулахгүйн тулд хамгийн сүүлийн үеийн технологи ашигладаг. Бидний хүлээн авсан бүх мэдээллийг хакердахаас хамгаалагдсан шифрлэлтийн технологи ашигладан дамжуулдаг. Бүх мэдээллийг манай тусгай серверүүд дээр хадагласны дараа бүх өгөгдөлийг хамгийн сүүлийн үеийн firewall программ ашиглан хамгаалдаг. Манай вэб сайт болон тоглоомын программ хангамж нь мэдээллийн үнэн зөв, нууцлалыг хангах, мөн өгөгдөлийг аливаа урвуулан ашиглах, алдахаас хамгаахын тулд боломжтой бүх хэрэгслийг ашигладаг.
    .accordion-item.info-tab-gaming
      h2.accordion-header
        button.accordion-button.collapsed(type='button' data-bs-toggle='collapse' data-bs-target='#collapseThree' aria-expanded='false' aria-controls='collapseThree') Тоглоомын Хариуцлага
      #collapseThree.accordion-collapse.collapse(data-bs-parent='#accordionInfo')
        .accordion-body
          .info-content
            p
              | Мөрийтэй тоглоом бол хөгжилтэй, зугаатай үр өгөөжтэй байх хэлбэр юм. UBWIN-нбагийнхан, мөрийтэй тоглох шийдвэр нь тоглогчийн үргэлж хувийн сонголт байх ёстой бөгөөд бусдын дарамт шахалтаар хийгээгүй гэдэгт итгэдэг. Бидний нэн тэргүүний зорилго бол бүх Тоглогчиддоо онлайн казино тоглох хамгийн сайн туршлагыг хангах явдал юм. Үүнийг бий болгохын тулд биднээс хүчин чармайлт гаргахаас гадна Тоглогч бүр хариуцлагатай тоглоомдоо тоглох шаардлагатай.
            p.mb-1 Дараах тохиолдолд хэзээ ч мөрийтэй тоглож болохгүй:
            ol
              li Та өөрийн харьяаллын дагуу мөрийтэй тоглоом тоглох хууль ёсны насанд хүрээгүй байх.
              li Энэ нь таныг ажлаа хийх, үүрэг хариуцлагаа биелүүлэхэд саад болох.
              li Та бусдаар хараат болон донтох эмгэгээр эмчлүүлж байгаа тохиолдолд.
              li Та согтууруулах ундаа болон бусад бодисын нөлөөн дор байгаа бол.
              li Та өмнөх мөрийтэй тоглоомын алдагдлаа нөхөхийг оролдож байгаа бол.
            p
              | Мөрийтэй тоглоомыг олон хүн зугаа цэнгэлийн үйл ажиллагаа гэж үздэг. Энэ нь ихэвчлэн өдөр тутмын амьдралын нэгэн хэвийн байдлаас зайлсхийх, цагийг хөгжилтэй өнгөрөөх хор хөнөөлгүй арга юм. Гэсэн хэдий ч цөөн тооны мөрийтэй тоглоомчидын хувьд  бага зэрэг хүндрэлтэй байдаг. Албадан донтсон мөрийтэй тоглоомчид онлайн болон газар дээр суурилсан тоглоомын бизнесүүдийн эерэг дүр төрхийг гутаадаг.
            p
              | UBWIN нь газар дээр суурилсан тоглоомын хамтрагчдын нэгэн адил тоглогчдоос албадлагын бооцоот тоглоомын шинж тэмдгийг илрүүлж, тодорхойлоход маш сайн бэлтгэгдэж, тоноглогдсон байдаг. Бидний зорилго бол бүх хүмүүст тав тухтай, дээд зэргийн тоглоомын орчинг бүрдүүлэх, мөн бидний тусламж хэрэгтэй байгаа хүмүүст нэгэн зэрэг туслах явдал юм.
            p
              | UBWIN нь нийгэмд ухамсартай байж, зөв тоглогчдынхоо хүсэлд нийцүүлэн чанартай үйлчилгээ үзүүлнэ гэдэгт итгэдэг. Тэдний урт хугацааны сайн туршлаган дээр  Казиногийн менежментийн салбар нь туршлагажиж [UBWIN] нь албадлагын мөрийтэй тоглоомын шинж тэмдгийг тодорхойлоход шаардлагатай ур чадвар,туршлагатай болсон юм. Энэхүү туршлагаараа казиногийн гадна хэрэгцээтэй байгаа донтож тоглогчдод туслах зорилготой юм.
            p
              | “Anonymous Gamblers” бол асуудалтай, донтогч тоглогчдод туслах, дэмжлэг үзүүлэх зорилгоор байгуулагдсан алдартай байгууллага юм. Энэхүү байгууллага  нь нэг нийтлэг шинж чанартай бөгөөд мөрийтэй тоглоом тоглохоо зогсоох ухамсартай хүсэл эрмэлзэлтэй эрэгтэй, эмэгтэй хүмүүсийн нэгдлээс бүрддэг. Тэд өөрсдийн туршлага, хүч чадлаа нэгтгэж, донтолтоо хамтдаа даван туулах болно гэж найдаж байна. Хэрэв танд эсвэл таны таньдаг хэн нэгэнд тэдний тусламж хэрэгтэй байгаа бол тэдэнтэй холбогдоно уу: www.gamblersanonymous.org.
    .accordion-item.info-tab-banking
      h2.accordion-header
        button.accordion-button.collapsed(type='button' data-bs-toggle='collapse' data-bs-target='#collapseFour' aria-expanded='false' aria-controls='collapseFour') Банк
      #collapseFour.accordion-collapse.collapse(data-bs-parent='#accordionInfo')
        .accordion-body
          .info-content
            p
              | UBWIN дээр та гүйлгээгээ хялбар, үр дүнтэй хийх боломжтой бөгөөд та мөнгө авах, мөнгө байршуулах олон янзын аргуудаас сонгох боломжтой юм. Доор үзүүлсэн манай банкны бүх сонголттой танилцаж, өөрт тохирох аргыг сонгоорой.
            .table-info.table-bank
              .table-responsive
                table.table.table-new
                  tr
                    td.align-middle(width='25%' rowspan='2')
                      strong Банкны Сонголт
                    td(colspan='2')
                      strong Гүйлгээний Хязгаар ({{ currency }})
                    td.align-middle.border-end-0(width='25%' rowspan='2')
                      strong Гүйлгээний цагын хуваарь
                  tr
                    td(width='25%')
                      strong Хамгийн Бага
                    td(width='25%')
                      strong Хамгийн Их
                  tr
                    th(colspan='4')
                      strong ДЕПОСИТ
                  tr
                    td
                      strong AMT / CDM
                    td.align-middle(rowspan='3') 10,000 {{ currency }}
                    td.align-middle(rowspan='3') 7,000,000 {{ currency }}
                    td.align-middle.border-end-0(rowspan='3') 5 Минут
                  tr
                    td
                      strong Онлайн Банкны Гүйлгээ
                  tr
                    td
                      strong Орон нутгын банк шилжүүлэлт
                  tr
                    th(colspan='4')
                      strong Татан Авалт
                  tr
                    td
                      strong Түргэн Татан авалт
                    td 40,000 {{ currency }}
                    td 4,000,000 {{ currency }}
                    td.border-end-0 15 Минут
                  tr
                    td
                      strong Орон нутгын банк шилжүүлэлт
                    td(colspan='2') 7,500,000 {{ currency }} ба түүнээс дээш
                    td.border-end-0 1 Өдөр
            p ТАЙЛБАР:
            ul
              li Бүх хамгийн дээд хэмжээний нэг удаагийн гүйлгээ нь нэг өдрийн гүйлгээнд үндэслэгдэнэ.
              li Бусад орон нутгийн банкны мэдээллийг авах бол манай шууд чатаар холбогдоно уу.
              li Мөнгө татаж авахаар бол бүх урьдчилагаа бооцоогоо тавьсан байх ёстой.
              li
                | Бид гүйлгээг нотлох хүсэлт гаргаж болзошгүй тул банкны баримт эсвэл гүйлгээний лавлагааны дугаарыг хадгална уу.
              li
                | Татан авалтын гүйлгээг хойшлогдохгүйн тулд татан авсан баримтыг баталгаагаа хавсаргаж, манай харилцагчийн үйлчилгээний ажилтантай холбогдоно уу.
              li
                | Бид таны тоглогчийн данснаас ямар нэгэн төлбөр хийхээс өмнө баталгаажуулах бичиг баримт шаардаж магадгүй бөгөөд их хэмжээний мөнгө гаргах тохиолдолд хугацаа орох магадлалтай.
              li
                | Зөвхөн UBWIN.com-д тоглогчийн бүртгэлээ бүртгүүлсэн нэр бүхий хувь хүн л зөвхөн мөнгө татахыг зөвшөөрнө.
              li
                | Та мөнгө татан авахад шаардагдах шалгууруудыг хангаагүй тохиолдол, татан авалт болон урамшуулал авах эрхгүй гэдгийг санаарай.
              li
                | Түргэн мөнгө авах нь зөвхөн дэмжигдсэн банкуудад өдөрт нэг дансанд арван гүйлгээ хийхээр хязгаарлагддаг.
    .accordion-item.info-tab-faqs
      h2.accordion-header
        button.accordion-button.collapsed(type='button' data-bs-toggle='collapse' data-bs-target='#collapseFive' aria-expanded='false' aria-controls='collapseFive') ТҮГЭЭМЭЛ АСУУЛТУУД
      #collapseFive.accordion-collapse.collapse(data-bs-parent='#accordionInfo')
        .accordion-body
          .info-content
            .faq Би UBWIN-д Тоглогчийн бүртгэлийг хэрхэн бүртгүүлэх вэ?
            p
              | Бид UBWIN дээр шинэ Тоглогчийн бүртгэл үүсгэхийг хэрэглэгчдэд маш хялбар болгосон юм. Хожих боломжоо эхлүүлэхийн тулд доор тайлбарласан энгийн алхмуудыг дагана уу.
            .faq БҮРТГЭЛИЙН УДИРДАМЖ
            .table-info
              .table-responsive.mt-3
                table.table.table-new
                  tr
                    th 1-Р АЛХАМ
                    td
                      | Нүүр хуудасны дээд хэсэгт байрлах "Одоо нэгдэх" товчийг дарахад л хангалттай. Энэ товчийг дарснаар таныг UBWIN вэбсайт дээрх албан ёсны бүртгэлийн маягт руу дахин чиглүүлэх болно.
                  tr
                    th 2-Р АЛХАМ
                    td
                      | Зааврыг дагаж, талбар бүрт заасан шаардлагатай мэдээллийг оруулна. Шаардлагатай мэдээлэлд эдгээр зайлшгүй шаардлагатай мэдээлэл орно:
                      .table-responsive.mt-3
                        table.table.table-new
                          tr
                            th Утасны дугаар
                            td
                              | Таны өгсөн хүчинтэй, ажиллагаатай утасны дугаар. Энэ мэдээллийг ирээдүйд Тоглогчийн бүртгэлд нэвтрэх, цаашдын харилцаа холбоо, сурталчилгаанд ашиглах болно.
                          tr
                            th.border-bottom-0 Нууц Үг
                            td
                              | [6 – 30] жижиг том үсгийн болон тэмдэгтүүдийн дараалал (үсэг, тоо, тэмдэг) дор хаяж 1 том үсгээр бичнэ нь таны Тоглогчийн бүртгэлд нэвтрэхэд зайлшгүй шаардлагатай нууц түлхүүр болгон ашигладаг
                  tr
                    th 3-Р АЛХАМ
                    td
                      | Бүртгэлийн маягтыг амжилттай бөглөж, бөглөсний дараа таны утасны дугаар руу илгээсэн мэндчилгээний мессежийг хүлээн авах бөгөөд үүнд таны нэвтрэх баталгаажуулсан мэдээлэл орно. Бүртгэлээ албан ёсоор идэвхжүүлэхийн тулд нэвтрэх дэлгэрэнгүй мэдээллээр нэвтэрнэ үү.
                  tr
                    th 4-р АЛХАМ
                    td UBWIN Тоглогчийн дансанд доод тал нь [10,000 MNT] мөнгө
                  tr
                    th 5-р АЛХАМ
                    td Мөнгө байршуулсан маягтаа оруулна уу.
                  tr
                    th.border-bottom-0 6-р АЛХАМ
                    td
                      | UBWIN-д мөнгөө байршуулсны дараа харилцагчийн үйлчилгээний ажилтнууд  хүлээн авсан баталгаажуулалт хийснээр та [UBWIN]-ын олон төрлийн казино тоглоомоос дурын тоглоом тоглож эхлэх боломжтой болно!
            p
              | UBWIN хэрэглэгч [насны хязгаарлалт 21]нaс болон түүнээс дээш байх ёстойг анхаарна уу. Бүртгэлээ хийснээр хэрэглэгч вэб сайтын ерөнхий нөхцөл болон болзлыг ойлгож, дагаж мөрдөхөө хүлээн зөвшөөрнө.
            .faq Би бүртгүүлсэн дансныхаа дэлгэрэнгүй мэдээллийг хэрхэн шинэчлэх, өөрчлөх болон/ бөглөх вэ?
            p
              | Тоглогчийн бүртгэлдээ нэвтэрч, "Хэрэглэгчийн тохиргоо" дээр товшоод профайлын дэлгэрэнгүй мэдээллийг шинэчлэх/өөрчлөх/бүрэн бөглөж гүйцээнэ үү. Шаардлагатай өөрчлөлтүүдийг хийсний дараа шинэчлэлтийг дуусгахын тулд "Хадгалах" товчийг дарна уу.
            .faq Би нууц үгээ хэрхэн өөрчлөх/шинэчлэх вэ?
            p
              | Нууц үгээ өөрчлөх/шинэчлэхийн тулд Тоглогчийн бүртгэлдээ нэвтэрч &quot;Бүртгэл&quot; дээр дарна уу. Хүссэн шинэ нууц үгээ оруулаад &quot;Хадгалах&quot; шинэчлэлтийг дуусгахын тулд товчийг дарна уу.
            .faq Хэрэв би нууц үгээ мартсан бол яах вэ?
            p
              | Нууц үгээ шинэчлэхийн тулд &quot;Нууц үгээ мартсан&quot; нүүр хуудсан дээрх товчлуур. Таны бүртгүүлсэн утасны дугаар руу түр зуурын шинэ нууц үг илгээгдэх болно. Тухайн нууц үгээ ашигласнаар та өөрийн Тоглогчийн бүртгэлдээ нэвтрэх бөгөөд нууц үгээ нэн даруй шинэчлэхийг зөвлөж байна.
            .faq Би яагаад бусад ижил төстэй сайтуудын оронд UBWIN дээр тоглох ёстой гэж?
            p
              | UBWIN түншүүдтэйгээ онцгой түншлэл байгуулснаар бусдаас ялгарч, дээгүүр байр эзэлдэг. Тиймээс зах зээл дээр байгаа хамгийн сайн чанартай, хамгийн өндөр хөнгөлөлтийг санал болгох боломжтой юм.
</template>
  
<script>
export default {
  computed: {
    generalMenuSelected() {
      return this.$store.getters.generalMenuSelected;
    },
    currency() {
      return this.$store.getters.currency;
    }
	},
  mounted() {
    $('.info-menu ul li a').click(function(){
      var info_tab = $(this).data('tab');        
      $('.info-menu ul li a').removeClass('active');
      $(this).addClass('active');
      $('.accordion-item').removeClass('active');
      $('.accordion-item.'+info_tab).addClass('active');
    });
  },
  methods: {
    setMenu(tab) {
      this.$store.dispatch("user/setGeneralMenuSelected", tab)
    }
  }
}
</script>